import React from 'react';
import { Link, useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useTheme, useMediaQuery, Box, Tabs, Tab, AppBar, Toolbar } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import useRoleBasedAccess from "../../commons/useRoleBasedAccess";
// import DESCOlogo from '../../images/DESCO.png';
import uniLogo from '../../images/UNI_LOGO_BLUE_SVG.svg';
import profileIcon from '../../images/profile_icon.png';

function CheckerLayout() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const location = useLocation();
    const [mainTab, setMainTab] = React.useState('0');
    const [subTab, setSubTab] = React.useState('0');

    useRoleBasedAccess(['CHECKER']);

    const ScrollToTop = () => {
        window.scrollTo(0, 0);
    };

    React.useEffect(() => {
        ScrollToTop();
        const pathSegments = location.pathname.split('/').filter(Boolean);
        const main = pathSegments[1] && pathSegments[1].includes('improvement') ? '1' : '0';
        let sub = '0';

        if (pathSegments[1] === 'improvement-registration-list') {
            sub = '0';
        } else if (pathSegments[1] === 'improvement-list') {
            sub = '1';
        } else if (pathSegments[1] === 'registered-list') {
            sub = '1';
        }

        setMainTab(main);
        setSubTab(sub);
    }, [location.pathname]);

    const handleMainChange = (event, newValue) => {
        const newPath = newValue === '0' ? 'to-register-list' : 'improvement-registration-list';
        setMainTab(newValue);
        setSubTab('0');
        navigate(`/checker/${newPath}`);
        ScrollToTop();
    };

    const handleSubChange = (event, newValue) => {
        let newPath;
        if (mainTab === '0') {
            newPath = newValue === '0' ? '/checker/to-register-list' : '/checker/registered-list';
        } else {
            newPath = newValue === '0' ? '/checker/improvement-registration-list' : '/checker/improvement-list';
        }
        ScrollToTop();
        setSubTab(newValue);
        navigate(newPath);
    };

    return (
        <>
            {/* AppBar with Safe Area 처리 */}
            <AppBar
                position="fixed"
                sx={{
                    width: '100%',
                    boxShadow: 'none',
                    bgcolor: '#fff',
                    zIndex: theme.zIndex.drawer + 1,
                    // iPhone Safe Area Top 처리
                    top: 'env(safe-area-inset-top)',
                    left: 'env(safe-area-inset-left)',
                    right: 'env(safe-area-inset-right)',
                }}
            >
                <Toolbar sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // Safe Area 추가 패딩
                    paddingLeft: 'max(16px, env(safe-area-inset-left))',
                    paddingRight: 'max(16px, env(safe-area-inset-right))',
                }}>
                    <Box component="img" src={uniLogo} sx={{ maxWidth: '70px' }}></Box>
                    <Link to="/checker/personal" style={{ textDecoration: 'none' }}>
                        <Box component="img" src={profileIcon} sx={{ width: '24px', height: '24px' }}></Box>
                    </Link>
                </Toolbar>

                {/* 탭 네비게이션 */}
                <Box sx={{ width: '100%' }}>
                    <TabContext value={`${mainTab}-${subTab}`}>
                        <Box sx={{
                            pt: 1,
                            pl: 2,
                            pr: 2,
                            // Safe Area 좌우 패딩 고려
                            paddingLeft: 'max(16px, env(safe-area-inset-left))',
                            paddingRight: 'max(16px, env(safe-area-inset-right))',
                        }}>
                            {/* 메인 탭 (점검목록 / 고장 A/S) */}
                            <Tabs
                                value={mainTab}
                                onChange={handleMainChange}
                                indicatorColor="none"
                                textColor="inherit"
                                variant="fullWidth"
                                sx={{
                                    borderRadius: '10px',
                                    color: '#fff',
                                    fontSize: '1.2rem',
                                    '& .MuiTab-root': {
                                        backgroundColor: 'var(--main-white-color)',
                                        color: '#000',
                                        fontSize: '1.4rem',
                                        margin: '0 4px',
                                        borderRadius: '8px',
                                    },
                                    '& .Mui-selected': {
                                        backgroundColor: 'var(--main-blue-color)',
                                        color: '#fff',
                                    },
                                }}
                            >
                                <Tab label="점검목록" value="0" />
                                <Tab label="고장 A/S" value="1" />
                            </Tabs>
                        </Box>

                        <Box sx={{ backgroundColor: 'white' }}>
                            <TabPanel value={`${mainTab}-${subTab}`} sx={{ pt: 1, pb: 0, px: 0, boxSizing: 'border-box' }}>
                                {mainTab === '0' ? (
                                    // 점검목록 서브탭 (등록 / 목록)
                                    <Tabs
                                        value={subTab}
                                        onChange={handleSubChange}
                                        variant="fullWidth"
                                        indicatorColor="primary"
                                        TabIndicatorProps={{
                                            style: {
                                                left: subTab === '0' ? '5%' : '50%',
                                                width: '45%',
                                            }
                                        }}
                                        sx={{
                                            '& .MuiTab-root': {
                                                color: 'rgb(112, 112, 112)',
                                                fontSize: '1.0rem',
                                            },
                                            '& .Mui-selected': {
                                                color: 'var(--main-blue-color)',
                                            },
                                        }}
                                    >
                                        <Tab label="등록" value="0" />
                                        <Tab label="목록" value="1" />
                                    </Tabs>
                                ) : (
                                    // 고장 A/S 서브탭 (작성 / 조회)
                                    <Tabs
                                        value={subTab}
                                        onChange={handleSubChange}
                                        variant="fullWidth"
                                        indicatorColor="primary"
                                        TabIndicatorProps={{
                                            style: {
                                                left: subTab === '0' ? '5%' : '50%',
                                                width: '45%',
                                            }
                                        }}
                                        sx={{
                                            '& .MuiTab-root': {
                                                color: 'rgb(112, 112, 112)',
                                                fontSize: '1.0rem',
                                            },
                                            '& .Mui-selected': {
                                                color: 'var(--main-blue-color)',
                                            },
                                        }}
                                    >
                                        <Tab label="작성" value="0" />
                                        <Tab label="조회" value="1" />
                                    </Tabs>
                                )}
                            </TabPanel>
                        </Box>
                    </TabContext>
                </Box>
            </AppBar>

            {/* 메인 컨텐츠 영역 with Safe Area 처리 */}
            <Box sx={{
                // Safe Area Top + AppBar 높이를 모두 고려한 marginTop
                marginTop: `calc(env(safe-area-inset-top) + 168px)`,
                width: '100%',
                padding: isMobile ? 0 : 0,
                backgroundColor: '#fff',
                // Safe Area 전체 패딩 적용
                paddingLeft: 'env(safe-area-inset-left)',
                paddingRight: 'env(safe-area-inset-right)',
                paddingBottom: 'env(safe-area-inset-bottom)',
                // 최소 높이를 Safe Area 고려하여 설정
                minHeight: `calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom) - 168px)`,
            }}>
                <Outlet />
            </Box>
        </>
    );
}

export default CheckerLayout;